import { Injectable } from '@angular/core';
import { KEYS } from '../constants/storage.constants';

@Injectable()
export class StorageLocalService {
	private isConsented: Boolean = false;

	constructor() {}

	public isLocalStorageEnabled() {
		return typeof Storage !== 'undefined';
	}

	public getStorageItem(name: string) {
		return JSON.parse(localStorage.getItem(name));
	}

	public deleteStorageItem(name) {
		localStorage.removeItem(name);
	}

	public clearStorage() {
		localStorage.clear();
	}

	public setStorageItem(storageTokenName, tokenName: string, tokenValue: string, expireDays: number) {
		const d: Date = new Date();
		const timestamp = d.getTime() + expireDays * 24 * 60 * 60 * 1000;
		const item: any = {};
		item[tokenName] = tokenValue;
		item[KEYS.EXPIRE_TOKEN] = timestamp;
		localStorage.setItem(storageTokenName, JSON.stringify(item));
	}
}
